import { CONFs, URLs } from '../config'
import http from './http'
import { objectToFormdata } from './common'

export const employee = {
    get: {
        // @Url /v1/staffs/{cbidx}
        staffs: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/employee
        employee: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/employee`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/detail-info/{idx}
        detailInfo: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/detail-info/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/memo/{idx}
        memo: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/memo/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/contract/{idx}
        contract: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/contract/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/contract-info/{idx}
        contractInfo: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/contract-info/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/contract-finish/{idx}
        contractFinish: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/contract-finish/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/members/bank-account/{idx}
        bankAccount: async(params) => {
            return await http.get(
                `${URLs.members}/bank-account/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/work/{idx}
        work: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/work/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/contract-file/{idx}
        contractFile: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/contract-file/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/staff-list
        staffList: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/staff-list`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/payslip
        payslip: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/payslip`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/payroll
        payroll: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/payroll`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/payroll-list
        payrollList: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/payroll-list`, {
                    params: params
                }
            )
        },
        // @Url /v1/permission/{cbidx}/users/{idx}
        usersPermission: async(params) => {
            return await http.get(
                `${URLs.permission}/${params.cbidx}/users`, {
                    params: params
                }
            )
        },
        // @Url /v1/members/{cbidx}/print-certificate
        printCertificate: async(params) => {
            return await http.get(
                `${URLs.members}/${params.cbidx}/print-certificate`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/offer-schedule
        offerSchedule: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/offer-schedule`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/work-info
        workInfo: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/work-info`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/qualify-acquis-print
        acquisPrint: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/qualify-acquis-print`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/qualify-loss-print
        lossPrint: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/qualify-loss-print`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/vacation-grant 휴가부여 내역 조회
        vacationGrant: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/vacation-grant`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/vacation-grant-type 휴가부여 분류별 조회
        vacationGrantType: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/vacation-grant-type`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/vacation-year
        useVacation: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/vacation-year`, {
                    params: params
                }
            )
        },
        // @Url v1/staffs/{cbidx}/vacation-basic-annual-basis/{idx} 직원의 기본연차 부여근거조회
        annualBasis: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/vacation-basic-annual-basis/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/staff-contract-list
        staffContractList: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/staff-contract-list`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/payslip-close
        payslipClose: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/payslip-close`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/insur4-qual-report
        insur4QualReport: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/insur4-qual-report`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/monthly-change-report
        monthlyChangeReport: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/monthly-change-report`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/payslip-detail/{idx}
        payslipDetail: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/payslip-detail/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/submit-file-list
        submitFileList: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/submit-file-list`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/nonwork-over30
        noWorkOver30: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/nonwork-over30`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/month-worktime 
        monthWorktime: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/month-worktime`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/longterm-work
        longtermWork: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/longterm-work`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/check
        staffCheck: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/check`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/staff-commute-calendar
        staffCommuteList: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/staff-commute-calendar`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/resign-list
        resignList: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/resign-list`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/state-setting
        stateSetting: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/state-setting`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/dash
        dash: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/dash`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/dash-paycosts
        dashPayCosts: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/dash-paycosts`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/dash-insure4
        dashInsure4: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/dash-insure4`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/essential-file-list
        essentialFileList: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/essential-file-list`, {
                    params: params
                }
            )
        },
        // @Url v1/staffs/{cbidx}/essential-file-year-list
        essentialFileYear: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/essential-file-year-list`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/payslip-detail-count
        payslipDetailCount: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/payslip-detail-count`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/retire-amount/month
        retireAmountMonth: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/retire-amount/month`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/retire-amount/year
        retireAmountYear: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/retire-amount/year`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/contract-finish-w4c/{idx}
        contractFinishW4C: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/contract-finish-w4c/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/4insurance-list
        insurance4List: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/4insurance-list`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/qualify-acquis
        qualifyAcquis: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/qualify-acquis`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/qualify-loss-info
        qualifyLoss: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/qualify-loss-info`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/qual-loss-pay
        qualLossPay: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/qual-loss-pay`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/monthly-change-report
        monthlyChangeReport: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/monthly-change-report`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/monthly-change-report-one
        monthlyChangeReportOne: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/monthly-change-report-one`, {
                    params: params
                }
            )
        },
        // @Url  /v1/staffs/{cbidx}/payslip-longwork-detail/{idx}
        payslipLongworkDetail: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/payslip-longwork-detail/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/payslip-seriousadd-detail/{idx}
        payslipSeriousaddDetail: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/payslip-seriousadd-detail/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/payslip-longdist-detail/{idx}
        payslipLongdistDetail: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/payslip-longdist-detail/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/payslip-nurseadd-detail/{idx}
        payslipNurseaddDetail: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/payslip-nurseadd-detail/${params.idx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/sync/excel/{cbidx}/error-check
        errorCheck: async(params) => {
            return await http.get(
                `/v1/sync/excel/${params.cbidx}/error-check`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/check-with-home
        checkWithHome: async(params) => {
            return await http.get(
                `${URLs.staffs}/${params.cbidx}/check-with-home`, {
                    params: params
                }
            )
        },
    },
    post: {
        // @Url /v1/staffs/{cbidx}/contract-reg/{idx}
        contractReg: async(params) => {
            return await http.post(
                `${URLs.staffs}/${params.cbidx}/contract-reg/${params.idx}`,
                params.data, {
                    params: {
                        luidx: params.luidx,
                        applyYear: params.applyYear,
                    },
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/contract-mod/{idx}
        contractMod: async(params) => {
            return await http.post(
                `${URLs.staffs}/${params.cbidx}/contract-mod/${params.idx}`,
                params.data, {
                    params: {
                        luidx: params.luidx,
                        applyYear: params.applyYear,
                    },
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/contract-change/{idx}
        contractChange: async(params) => {
            return await http.post(
                `${URLs.staffs}/${params.cbidx}/contract-change/${params.idx}`,
                params.data, {
                    params: {
                        luidx: params.luidx,
                        applyYear: params.applyYear,
                    },
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/contract-cancel/{idx}
        contractCancel: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.staffs}/${params.cbidx}/contract-cancel/${params.idx}`, formData
            )
        },
        // @Url /v1/staffs/{cbidx}/profile-file/{idx}
        profileFile: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.staffs}/${params.cbidx}/profile-file/${params.idx}`, formData
            )
        },
        // @Url /v1/staffs/{cbidx}/memo/{idx}
        memo: async(params) => {
            let formData = objectToFormdata(params)
            if (params.files) {
                params.files.forEach((item, i) => {
                    formData.append(`fileNameList[${i}]`, item.name)
                    formData.append(`fileEncList[${i}]`, item.encByte)
                    formData.append(`file[${i}]`, item.file)
                })
            }
            return await http.post(
                `${URLs.staffs}/${params.cbidx}/memo/${params.idx}`, formData
            )
        },
        // @Url /v1/staffs/{cbidx}/memo/{idx}/{midx}
        updateMemo: async(params) => {
            let formData = objectToFormdata(params)
            if (params.files) {
                params.files.forEach((item, i) => {
                    formData.append(`fileNameList[${i}]`, item.name)
                    formData.append(`fileEncList[${i}]`, item.encByte)
                    formData.append(`file[${i}]`, item.file)
                })
            }
            return await http.post(
                `${URLs.staffs}/${params.cbidx}/memo/${params.idx}/${params.midx}`, formData
            )
        },
        // @Url /v1/staffs/{cbidx}/contract-confirm/{idx}
        contractConfirm: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.staffs}/${params.cbidx}/contract-confirm/${params.idx}`, formData,
            )
        },
        // @Url /v1/members/bank-account/{idx}
        bankAccount: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.members}/bank-account/${params.idx}`, formData
            )
        },
        // @Url /v1/staffs/{cbidx}/detail-info/{idx}
        detailInfo: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.staffs}/${params.cbidx}/detail-info/${params.idx}`, formData
            )
        },
        // @Url /v1/staffs/{cbidx}/file-upload/{idx}
        fileUpload: async(params) => {
            let formData = objectToFormdata(params)
            if (params.files) {
                params.files.forEach((item, i) => {
                    formData.append(`fileNameList[${i}]`, item.name)
                    formData.append(`fileEncList[${i}]`, item.encByte)
                    formData.append(`file[${i}]`, item.file)
                })
            }
            return await http.post(
                `${URLs.staffs}/${params.cbidx}/file-upload/${params.idx}`, formData
            )
        },
        // @Url /v1/staffs/{cbidx}/file-upload-list
        fileUploadList: async(params) => {
            let formData = objectToFormdata(params)
            if (params.files) {
                params.files.forEach((item, i) => {
                    formData.append(`fileNameList[${i}]`, item.name)
                    formData.append(`fileEncList[${i}]`, item.encByte)
                    formData.append(`file[${i}]`, item.file)
                })
            }
            return await http.post(
                `${URLs.staffs}/${params.cbidx}/file-upload-list`, formData
            )
        },
        // @Url /v1/staffs/{cbidx}/file-upload-list
        fileUploadList: async(params) => {
            let formData = objectToFormdata(params)
            if (params.files) {
                params.files.forEach((item, i) => {
                    formData.append(`fileNameList[${i}]`, item.name)
                    formData.append(`fileEncList[${i}]`, item.encByte)
                    formData.append(`file[${i}]`, item.file)
                })
            }
            return await http.post(
                `${URLs.staffs}/${params.cbidx}/file-upload-list`, formData
            )
        },
        // @Url /v1/permission/{cbidx}/users/{idx}
        usersPermission: async(params) => {
            return await http.post(
                `${URLs.permission}/${params.cbidx}/users/${params.idx}`,
                params, {
                    params: {
                        luidx: params.luidx,
                    }
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/vacation-basic-annual-calc 기본연차 일괄계산
        basicAnnualCalc: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.staffs}/${params.cbidx}/vacation-basic-annual-calc`, formData
            )
        },
        // @Url /v1/staffs/{cbidx}/vacation-basic-annual/{idx} 기본연차 변경
        basicAnnual: async(params) => {
            return await http.post(
                `${URLs.staffs}/${params.cbidx}/vacation-basic-annual/${params.idx}`,
                params.annualGrantBaseList, {
                    params: {
                        luidx: params.luidx
                    }
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/vacation-grant 직원 휴가 부여
        vacationGrant: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.staffs}/${params.cbidx}/vacation-grant`, formData
            )
        },
        // @Url /v1/staffs/{cbidx}/vacation-grants 직원 휴가(일괄) 부여
        vacationGrants: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.staffs}/${params.cbidx}/vacation-grants`, formData
            )
        },
        // @Url /v1/staffs/{cbidx}/vacation-annual-use/{idx} 연차사용여부 변경
        vacationUse: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.staffs}/${params.cbidx}/vacation-annual-use/${params.idx}`, formData
            )
        },
        // @Url /v1/staffs/{cbidx}/payslip-close
        payslipClose: async(params) => {
            return await http.post(
                `${URLs.staffs}/${params.cbidx}/payslip-close`,
                params.data, {
                    params: {
                        luidx: params.luidx,
                        yearMonth: params.yearMonth,
                        closeType: params.closeType
                    }
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/state-setting
        stateSetting: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.staffs}/${params.cbidx}/state-setting`,
                formData,
            )
        },
        // @Url /v1/staffs/{cbidx}/active/{idx}
        active: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.staffs}/${params.cbidx}/active/${params.idx}`, formData
            )
        },
        // @Url /v1/staffs/{cbidx}/require-file/{idx}
        requireFile: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.staffs}/${params.cbidx}/require-file/${params.idx}`, formData
            )
        },
        // @Url /v1/staffs/{cbidx}/active
        activeAll: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.staffs}/${params.cbidx}/active`, formData
            )
        },
        // @Url /v1/staffs/{cbidx}/resign-forced/{idx}
        resignForced: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.staffs}/${params.cbidx}/resign-forced/${params.luidx}`, formData
            )
        },
        // @Url /v1/staffs/{cbidx}/retire-amount
        retireAmount: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.staffs}/${params.cbidx}/retire-amount`, formData
            )
        },
        // @Url /v1/staffs/{cbidx}/retire-amount-all 
        retireAmountAll: async(params) => {
            return await http.post(
                `${URLs.staffs}/${params.cbidx}/retire-amount-all`,
                params.data, {
                    params: {
                        luidx: params.luidx,
                        payYm: params.payYm
                    }
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/hidden
        hidden: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.staffs}/${params.cbidx}/hidden`, formData
            )
        },
        // @Url /v1/staffs/{cbidx}/qualify-acquis
        qualifyAcquis: async(params) => {
            return await http.post(
                `${URLs.staffs}/${params.cbidx}/qualify-acquis`,
                params, {
                    params: {
                        luidx: params.luidx,
                        syncYn: params.syncYn
                    }
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/qualify-loss
        qualifyLoss: async(params) => {
            return await http.post(
                `${URLs.staffs}/${params.cbidx}/qualify-loss`,
                params, {
                    params: {
                        luidx: params.luidx,
                        syncYn: params.syncYn
                    }
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/monthly-change-report
        monthlyChangeReport: async(params) => {
            return await http.post(
                `${URLs.staffs}/${params.cbidx}/monthly-change-report`,
                params, {
                    params: {
                        luidx: params.luidx,
                        syncYn: params.syncYn
                    }
                }
            )
        },
        // @Url /v1/sync/{cbidx}/delete-staff-payslip 
        deleteStaffPayslip: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `/v1/sync/${params.cbidx}/delete-staff-payslip`, formData
            )
        },
        // @Url /v1/auth/so/sync-calculate-salary
        syncCalculateSalary: async(params) => {
            return await http.post(
                `/v1/auth/so/delete-staff-payslip`, params
            )
        },
        // @Url /v1/staffs/{cbidx}/payslip-close-upd
        payslipCloseUpd: async(params) => {
            return await http.post(
                `${URLs.staffs}/${params.cbidx}/payslip-close-upd`,
                params.payslipDto, {
                    params: {
                        luidx: params.luidx,
                        cbidx: params.cbidx,
                    }
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/payslip-longwork-tempget/{idx}
        payslipLongworkTempget: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.staffs}/${params.cbidx}/payslip-longwork-tempget/${params.idx}`,
                formData
            )
        },
        // @Url /v1/staffs/{cbidx}/payslip-seriousadd-tempget/{idx}
        payslipSeriousaddTempget: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.staffs}/${params.cbidx}/payslip-seriousadd-tempget/${params.idx}`,
                formData
            )
        },
        // @Url /v1/staffs/{cbidx}/payslip-longdist-tempget/{idx}
        payslipLongdistTempget: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.staffs}/${params.cbidx}/payslip-longdist-tempget/${params.idx}`,
                formData
            )
        },
        // @Url /v1/staffs/{cbidx}/payslip-nurseadd-tempget/{idx}
        payslipNurseaddTempget: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.staffs}/${params.cbidx}/payslip-nurseadd-tempget/${params.idx}`,
                formData
            )
        },
        // @Url /v1/recipients/{cbidx}/sync-recipient-ministry 
        syncMinistry: async(params) => {
            let formData = objectToFormdata(params)
            return await http.post(
                `${URLs.recipients}/${params.cbidx}/sync-recipient-ministry`, formData
            )
        }
    },
    delete: {
        // @Url /v1/members/file-upload/{idx}
        fileUpload: async(params) => {
            return await http.delete(
                `${URLs.members}/file-upload/${params.idx}`
            )
        },
        // @Url /v1/staffs/{cbidx}/memo/{idx}/{midx}
        memo: async(params) => {
            return await http.delete(
                `${URLs.staffs}/${params.cbidx}/memo/${params.idx}/${params.midx}`, {
                    params: params
                }
            )
        },
        // @Url /v1/staffs/{cbidx}/vacation-grant/{idx} 휴가부여 삭제
        vacationGrant: async(params) => {
            return await http.delete(
                `${URLs.staffs}/${params.cbidx}/vacation-grant/${params.idx}`, {
                    params: params
                }
            )
        }
    }
}


// WEBPACK FOOTER //
// ./src/api/employees.js